import { Injectable } from '@angular/core';
import { URLSearchParams, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { ApiService } from '../shared/services/api.service';
import { RequestOptions, Request, RequestMethod } from '@angular/http';

@Injectable()
export class reportService {

  baseURL =  "/api/mvp"
  constructor(
    private apiService: ApiService
  ) { }

  

  searchReports(data) {
        return this.apiService.post(this.baseURL + '/lead/leaddetailreport', data)
            .map(
            (response: Response) => {
                return response;
            }
            )
            .catch(
            (error: Response) => {
                return Observable.throw('Something went wrong');
            }
            );
    }

     GetCreditSupervisors() {
        return this.apiService.get(this.baseURL + '/getleadcreators')
            .map(
            (response: Response) => {
                return response;
            }
            )
            .catch(
            (error: Response) => {
                return Observable.throw('Something went wrong');
            }
            );
    }


}



// WEBPACK FOOTER //
// ./src/app/Reports/reports.service.ts